import { useEffect, useState } from 'react';
import type { HelpCenterCategory } from '../utils/helpCenterCategories';

export type HelpCenterArticle = {
  slug: string;
  title: string;
  file: string;
  category?: HelpCenterCategory | string;
};

type HelpCenterManifest = {
  articles?: HelpCenterArticle[];
};

export type HelpCenterCatalogStatus = 'loading' | 'ready' | 'error';

export function useHelpCenterCatalog() {
  const [articles, setArticles] = useState<HelpCenterArticle[]>([]);
  const [status, setStatus] = useState<HelpCenterCatalogStatus>('loading');

  useEffect(() => {
    let isMounted = true;

    fetch('/help-center/manifest.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Help Center catalog HTTP ${response.status}`);
        }
        return response.json() as Promise<HelpCenterManifest>;
      })
      .then((manifest) => {
        if (isMounted) {
          setArticles(manifest.articles ?? []);
          setStatus('ready');
        }
      })
      .catch((error) => {
        console.error('Failed to load Help Center catalog', { error });
        if (isMounted) {
          setStatus('error');
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return { articles, status };
}
